export default __webpack_public_path__ + "static/media/03.d194e01e.png";